import { ReportResultProps } from '../../../../../../../../../../core/reports/types';
import { GipReportStatsAndNavigation } from '../../../../common/GipReportStatsAndNavigation';
import { GipReportType } from '../../../config/form/types';

export const GipReportResultV2 = (p: ReportResultProps<GipReportType>) => {
  return <GipReportStatsAndNavigation defaultActiveChip="with-matches" useLongLabel />;
};
